export class Sellers {
  constructor (api) {
    this.api = api;
  }

  getSaleProcess = (id) => this.api.get(`/api/sellers/sale_processes/${id}`).then(({ data }) => data);
}
